import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  reports: [],
};

function handleRequest(state: State): State {
  return { ...state, request: setRequestStateToPending() };
}

function handleSuccess(
  state: State,
  { reports }: Boundaries["retrieveZonesProjectsReports"]["success"],
): State {
  return { ...state, reports, request: setRequestStateToSuccess() };
}

function handleFailure(state: State): State {
  return { ...state, request: setRequestStateToFailure() };
}

function handleRemoveReport(
  state: State,
  { report }: Boundaries["removeProjectReport"]["success"],
): State {
  return {
    ...state,
    reports: state.reports.filter(({ report: r }) => r.uuid !== report.uuid),
  };
}

function handleEditReport(
  state: State,
  { report }: Boundaries["editProjectReport"]["success"],
): State {
  return {
    ...state,
    reports: state.reports.filter(({ report: r }) =>
      r.uuid === report.uuid ? report : r,
    ),
  };
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveZonesProjectsReportsRequested]: handleRequest,
    [events.retrieveZonesProjectsReportsSucceeded]: handleSuccess,
    [events.retrieveZonesProjectsReportsFailed]: handleFailure,
    [events.removeProjectReportSucceeded]: handleRemoveReport,
    [events.editProjectReportSucceeded]: handleEditReport,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
